import axios from "axios";
import {API_URL} from "../config";

export const listRolesService = async (params) => {
    return axios.get(`${API_URL}/roles`, {
        params: {
            ...params
        }
    });
}
